module.exports = __webpack_public_path__ + "static/img/service.07b0048f.png";